import React from 'react';
import { Box, Chip, IconButton, MenuItem, Select, TableCell, TableRow } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';
import ClearIcon from '@mui/icons-material/Clear';
import { useSuperDuper } from '../../context/SuperDuperContext';
import { getAgeCategory, getStatusColor } from '../../utils/subscriptionUtils';

const SubscriptionRow = ({ subscription }) => {
  const {
    editingEdition,
    editionValue,
    setEditionValue,
    handleEditEdition,
    handleSaveEdition,
    handleCancelEditionEdit
  } = useSuperDuper();

  const ageCategory = getAgeCategory(subscription.childDetails?.age);

  return (
    <TableRow>
      <TableCell>{subscription.customerName}</TableCell>
      <TableCell>{subscription.email}</TableCell>
      <TableCell>{subscription.phone}</TableCell>
      <TableCell>
        {subscription.childDetails?.age ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <span>{subscription.childDetails.age}</span>
            {ageCategory && (
              <Chip
                label={ageCategory}
                size="small"
                color={
                  ageCategory === 'Beginner' ? 'success' :
                  ageCategory === 'Junior' ? 'primary' :
                  'secondary'
                }
                variant="outlined"
              />
            )}
          </Box>
        ) : '-'}
      </TableCell>
      <TableCell>
        {editingEdition === subscription._id ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Select
              size="small"
              value={editionValue}
              onChange={(e) => setEditionValue(e.target.value)}
              sx={{ width: 150 }}
            >
              <MenuItem value="beginner">beginner</MenuItem>
              <MenuItem value="junior">junior</MenuItem>
              <MenuItem value="senior">senior</MenuItem>
            </Select>
            <IconButton
              size="small"
              color="primary"
              onClick={() => handleSaveEdition(subscription._id)}
            >
              <SaveIcon fontSize="small" />
            </IconButton>
            <IconButton
              size="small"
              onClick={handleCancelEditionEdit}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          </Box>
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <span>{subscription.edition || '-'}</span>
            <IconButton
              size="small"
              onClick={() => handleEditEdition(subscription._id, subscription.edition)}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </Box>
        )}
      </TableCell>
      <TableCell>
        <Chip
          label={subscription.period || 'N/A'}
          color={subscription.period === 'monthly' ? 'primary' : subscription.period === 'yearly' ? 'secondary' : 'default'}
          size="small"
          variant="outlined"
        />
      </TableCell>
      <TableCell>
        {subscription.couponCode ? (
          <Chip
            label={subscription.couponCode}
            color="success"
            size="small"
            variant="outlined"
          />
        ) : (
          '-'
        )}
      </TableCell>
      <TableCell>{subscription.subscriptionId}</TableCell>
      <TableCell>
        {subscription.paymentDetails?.razorpay_payment_id || '-'}
      </TableCell>
      <TableCell>
        <Chip
          label={subscription.status}
          color={getStatusColor(subscription.status)}
          size="small"
        />
      </TableCell>
      <TableCell>{subscription.createdAt ? new Date(subscription.createdAt).toLocaleString() : 'N/A'}</TableCell>
      <TableCell>{subscription.cancelledAt ? new Date(subscription.cancelledAt).toLocaleString() : '-'}</TableCell>
    </TableRow>
  );
};

export default SubscriptionRow;
